import { fetchProductsById } from "@/api/products";
import { fetchProductsByName } from "@/api/products";
import { fetchProductBySlug } from '@/api/products';
import { fetchProductsWithCategory } from "@/api/products";
import { fetchProductsWithTag } from "@/api/products";
import { fetchProductsWithCategoryAndTag } from "@/api/products";
import { fetchProductsWithCategoryAndName } from "@/api/products";
import { fetchProductVariations } from "@/api/products";
import { fetchProductVariation } from "@/api/products";

const ONE_HOUR = 5 * 60 * 1000;

const products = {
  state: {
    products: {}
  },

  mutations: {
    ADD_PRODUCT: (state, {id, data}) => {
      //console.log(id, data)
      state.products[id] = { lastUpdate: new Date(), products: data };
    },
  },
  actions: {
    fetchProductsById({ commit, state }, searchData) {
      return new Promise((resolve, reject) => {
        if (state.products[searchData.id] &&
          Date.parse(new Date()) - Date.parse(state.products[searchData.id].lastUpdate) < ONE_HOUR) {
            resolve(state.products[searchData.id].products);
        } else {
          fetchProductsById(searchData.products)
            .then(data => {
              commit("ADD_PRODUCT", { id: name, data: data });
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    fetchProductsByName({commit, state}, name) {
      return new Promise((resolve, reject) => {
        if (state.products[name] &&
          Date.parse(new Date()) - Date.parse(state.products[name].lastUpdate) < ONE_HOUR) {
            resolve(state.products[name].products);
        } else {
          fetchProductsByName(name).then((data) => {
            commit('ADD_PRODUCT', { id: name, data: data });
            resolve(data);
          }).catch(err => {
            reject(err);
          })
        }
      });
    },
    fetchProductBySlug({commit, state}, name) {
      return new Promise((resolve, reject) => {
        if (state.products[name] &&
          Date.parse(new Date()) - Date.parse(state.products[name].lastUpdate) < ONE_HOUR) {
            resolve(state.products[name].products);
        } else {
          fetchProductBySlug(name).then((data) => {
            commit('ADD_PRODUCT', { id: name, data: data });
            resolve(data);
          }).catch(err => {
            reject(err);
          })
        }
      });
    },
    fetchProductsWithCategory({commit, state}, name) {
      return new Promise((resolve, reject) => {
        if (state.products[name] &&
          Date.parse(new Date()) - Date.parse(state.products[name].lastUpdate) < ONE_HOUR) {
            resolve(state.products[name].products);
        } else {
          fetchProductsWithCategory(name).then((data) => {
            commit('ADD_PRODUCT', { id: name, data: data });
            resolve(data);
          }).catch(err => {
            reject(err);
          })
        }
      });
    },
    fetchProductsWithTag({commit, state}, name) {
      return new Promise((resolve, reject) => {
        if (state.products[name] &&
          Date.parse(new Date()) - Date.parse(state.products[name].lastUpdate) < ONE_HOUR) {
            resolve(state.products[name].products);
        } else {
          fetchProductsWithTag(name).then((data) => {
            commit('ADD_PRODUCT', { id: name, data: data });
            resolve(data);
          }).catch(err => {
            reject(err);
          })
        }
      });
    },
    fetchProductsWithCategoryAndTag({commit, state}, searchData) {
      return new Promise((resolve, reject) => {
        if (state.products[searchData.id] &&
          Date.parse(new Date()) - Date.parse(state.products[searchData.id].lastUpdate) < ONE_HOUR) {
          resolve(state.products[searchData.id].products);
        } else {
          fetchProductsWithCategoryAndTag(searchData.cats, searchData.tag)
            .then(data => {
              commit("ADD_PRODUCT", {
                id: searchData.id,
                data: data
              });
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    fetchProductsWithCategoryAndName({ commit, state }, searchData) {
      return new Promise((resolve, reject) => {
        if (state.products[searchData.id] &&
          Date.parse(new Date()) - Date.parse(state.products[searchData.id].lastUpdate) < ONE_HOUR) {
            resolve(state.products[searchData.id].products);
        } else {
          fetchProductsWithCategoryAndName(searchData.cats, searchData.name)
            .then(data => {
              commit("ADD_PRODUCT", {
                id: searchData.id,
                data: data
              });
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    fetchProductVariations({ commit, state }, searchData) {
      return new Promise((resolve, reject) => {
        if (state.products[searchData.id] &&
          Date.parse(new Date()) - Date.parse(state.products[searchData.id].lastUpdate) < ONE_HOUR) {
            resolve(state.products[searchData.id].products);
        } else {
          fetchProductVariations(searchData.id)
            .then(data => {
              commit("ADD_PRODUCT", {
                id: searchData.id,
                data: data
              });
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    fetchProductVariation({ commit, state }, searchData) {
      return new Promise((resolve, reject) => {
        if (state.products[searchData.pId + '_' + searchData.vId] &&
          Date.parse(new Date()) - Date.parse(state.products[searchData.pId + '_' + searchData.vId].lastUpdate) < ONE_HOUR) {
            resolve(state.products[searchData.pId + '_' + searchData.vId].products);
        } else {
          fetchProductVariation(searchData.pId, searchData.vId)
            .then(data => {
              commit("ADD_PRODUCT", {
                id: searchData.pId + '_' + searchData.vId,
                data: data
              });
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    }
  }
};

export default products;
